import jquery from 'jquery';

window.jQuery = jquery;
window.moment = require('moment');
window.THANOS_QUERY_URL = '';
window.THANOS_TENANT_HEADER = '';
window.THANOS_DEFAULT_TENANT = '';
window.THANOS_DISPLAY_TENANT_BOX = '';
